<template>
  <div v-if="viewState.loading">
    <p>Loading...</p>
  </div>
  <div v-if="viewState.event">
    <HeroBanner
      :bgSrc="viewState.event.imageUrl"
      :imgSrc="viewState.event.imageUrl"
    />
    <div class="bg-grey-100">
      <div class="mx-auto py-12 lg:py-24 px-4 sm:px-6 lg:max-w-5xl lg:px-8">
        <h2 class="sr-only">Checkout Options</h2>
        <h1 class="text-3xl font-bold text-gray-900 mb-2">
          Select an option:
        </h1>
        <div class="grid gap-6 pt-6">
          <OptionCard
            v-for="option in viewState.options"
            :key="option.id"
            :option="option"
            @select="navigateOption"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, useStore } from 'vuex'
import { defineComponent, onMounted, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import HeroBanner from '@/components/HeroBanner.vue'
import OptionCard from '@/components/OptionCard.vue'

export default defineComponent({
  components: {
    HeroBanner,
    OptionCard
  },
  setup () {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()

    const viewState = reactive({
      loading: true,
      loadError: undefined,
      event: undefined,
      options: undefined
    })

    onMounted(async () => {
      try {
        if (route.params.dataType && route.params.dataType.toLowerCase() === 'event') {
          const result = await store.dispatch('checkout/getEventOptions', {
            eventId: route.params.recordId
          })
          viewState.event = result.event
          if (viewState.event && viewState.event.imageUrl) {
            viewState.event.imageUrl = process.env.VUE_APP_BLOB_CONTAINER + '/images/' + viewState.event.imageUrl
          }
          viewState.options = result.options
          viewState.loading = false
        }
      } catch (e) {
        viewState.ticketInfo = undefined
        viewState.loadError = e
        store.commit('global/setErrorModal', {
          title: 'Error Loading',
          description: 'Please refresh the page and try again. If the problem persists, please contact support.',
          open: true
        })
      }
    })

    const navigateOption = (option) => {
      if (option.url) {
        if (option.url.startsWith('http')) {
          window.open(option.url, '_blank')
        } else {
          router.push(option.url)
        }
      } else {
        router.push(route.fullPath + '/' + option.id)
      }
    }

    return {
      viewState,
      navigateOption
    }
  },
  computed: {
    ...mapGetters([
      'isLoggedIn'
    ])
  }
})
</script>
